const SDK_URL_SANDBOX = "https://sandbox.web.squarecdn.com/v1/square.js";
const SDK_URL_PROD = "https://web.squarecdn.com/v1/square.js";

export const isSquareSandbox = () =>
  (process.env.REACT_APP_SQUARE_ENVIRONMENT || "").toLowerCase().includes("sandbox");

let sdkLoadPromise = null;
export function loadSquareSdk() {
  if (window.Square) return Promise.resolve(window.Square);
  if (sdkLoadPromise) return sdkLoadPromise;
  sdkLoadPromise = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = isSquareSandbox() ? SDK_URL_SANDBOX : SDK_URL_PROD;
    s.async = true;
    s.onload = () => resolve(window.Square);
    s.onerror = () => { sdkLoadPromise = null; reject(new Error("Failed to load Square SDK")); };
    document.head.appendChild(s);
  });
  return sdkLoadPromise;
}

// One shared `payments` instance per page — the card form and the wallet
// buttons must not each create their own.
let paymentsPromise = null;
export function getSquarePayments() {
  const appId = process.env.REACT_APP_SQUARE_APPLICATION_ID;
  const locationId = process.env.REACT_APP_SQUARE_LOCATION_ID;
  if (!appId || !locationId) return Promise.reject(new Error("Payment not configured"));
  if (!paymentsPromise) {
    paymentsPromise = loadSquareSdk()
      .then((Square) => Square.payments(appId, locationId))
      .catch((e) => { paymentsPromise = null; throw e; });
  }
  return paymentsPromise;
}
